import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Select from '@material-ui/core/Select'
import InputBase from '@material-ui/core/InputBase'
import cx from 'classnames'

const styles = theme => ({
  root: {
    width: '100%',
    borderRadius: 4,
  },
  formControl: {
    width: '100%',
  },
  icon: {
    top: 'calc(50% - 19px)',
    right: 8,
  },
  outlined: {
    borderRadius: 4,
    border: 'solid 1px rgb(187, 187, 187)',
  },
  select: {
    '&:focus': {
      borderRadius: 4,
      border: 'solid 1px #9371ff',
      backgroundColor: '#fff',
    },
  },
  invalid: {
    border: 'solid 1px #ff4e44',
  },
  btnFieldClear: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '5px 12px',
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%',
    cursor: 'pointer',
    border: 0,
    backgroundColor: 'transparent',
    outline: 'none',
  },
})

const Input = withStyles(theme => ({
  input: {
    color: 'rgb(0, 0, 0)',
    borderRadius: 4,
    position: 'relative',
    backgroundColor: '#fff',
    border: 'solid 1px rgb(187, 187, 187)',
    fontSize: 16,
    width: 288,
    marginBottom: 16,
    padding: '12px 30px 11px 20px',
    transition: theme.transitions.create(['border']),
    '&:focus': {
      borderRadius: 4,
      border: 'solid 1px #9371ff',
    },
  },
}))(InputBase)

const renderSelectField = ({
  input,
  label,
  meta,
  children,
  classes,
  ...custom
}) => (
  <div className={classes.formControl}>
    <Select
      {...input}
      variant="outlined"
      displayEmpty
      input={<Input />}
      classes={{
        root: classes.root,
        icon: classes.icon,
        outlined: cx(classes.outlined, {
          [classes.invalid]: meta.touched && meta.invalid,
        }),
        disabled: classes.disabled,
        select: classes.select,
        selectMenu: classes.selectMenu,
      }}
    >
      {children}
    </Select>
    {meta.error && meta.touched && <div>{meta.error}</div>}
  </div>
)

export default withStyles(styles)(renderSelectField)
